import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import COLOR_MAP from '../../../../constants/color-mapping';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';
import { capitalizeFirstLetter } from '../../../../utils/textFormatUtils';

const DrugDiseaseContraIndication = forwardRef(function (
  { drugDiseaseContraIndication },
  ref,
) {
  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="drug-disease-contra-indication-section"
    >
      <h4 className="accordion-header">Drug-Disease Contraindications</h4>
      <div className="accordion-body show">
        {drugDiseaseContraIndication?.DrugDiseaseContraindications?.length ? (
          <div>
            <div className="row">
              <div className="col-lg-3 col-sm-4 col-12 drug-info font-semibold">
                <p>
                  <span className="red-dot"></span>
                  <label>Contraindication</label>
                </p>
              </div>
              <div className="col-lg-3 col-sm-4 col-12 drug-info">
                <p>
                  <span className="orange-dot"></span>
                  <label>Severe Warning</label>
                </p>
              </div>
              <div className="col-lg-3 col-sm-4 col-12 drug-info">
                <p>
                  <span className="yellow-dot"></span>
                  <label>Moderate Warning</label>
                </p>
              </div>
            </div>
            <div>
              <ul className="disease-list">
                {drugDiseaseContraIndication.DrugDiseaseContraindications.map(
                  (condition, index) => (
                    <li key={`disease-condition-${index}`}>
                      <span
                        className={
                          COLOR_MAP.DrugDiseaseContraIndications[
                            condition.SeverityDesc
                          ]
                        }
                      />
                      {capitalizeFirstLetter(condition.ConditionDesc)}
                    </li>
                  ),
                )}
              </ul>
            </div>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

DrugDiseaseContraIndication.propTypes = {
  drugDiseaseContraIndication: PropTypes.object.isRequired,
};

DrugDiseaseContraIndication.displayName = 'DrugDiseaseContraIndication';

export default DrugDiseaseContraIndication;
